// Disable scroll-triggered animations when the page loads at a scrolled position
// to avoid blank sections; re-evaluate after each navigation.
export default defineNuxtPlugin((nuxtApp) => {
  if (process.server) return;

  const disableClass = "scroll-animations-disabled";
  const startThreshold = 200;

  const toggleAnimationGate = () => {
    const shouldDisable = window.scrollY > startThreshold;
    document.documentElement.classList.toggle(disableClass, shouldDisable);
  };

  toggleAnimationGate();
  window.addEventListener("pageshow", toggleAnimationGate, { once: true });
  window.addEventListener("load", () => requestAnimationFrame(toggleAnimationGate), {
    once: true,
  });
  nuxtApp.hook("page:finish", () => { requestAnimationFrame(toggleAnimationGate); });
});
